module.exports = BD.Model.extend({
    organization: BD.belongsTo('Billy.Organization'),
    createdTime: BD.attr('datetime', { readonly: true }),
    owner: BD.belongsToReference({ isParent: true }),
    file: BD.belongsTo('Billy.File')
})
